import Vue from 'vue'
import modules from './modules'
import {
  castArray, findIndex, isArray, isPlainObject, stateList,
} from '../views/utils'

function buildStoreMutations({ isClearable, storeKey, storeSuffix }) {
  const storeMutations = {
    ADD: (state, entries) => {
      const list = stateList(state[storeKey])

      // fix bug where entries array is an object
      const entriesValues = (isPlainObject(entries) && entries[0])
        ? Object.values(entries)
        : entries

      if (!Object.keys(list).length) {
        // fast overwrite
        Vue.set(state[storeKey], 'list', entriesValues.reduce((acc, entry) => ({
          ...acc,
          [entry.id]: entry,
        }), {}))
      } else {
        // one by one
        castArray(entriesValues)
          .filter(entry => !!entry)
          .forEach((entry) => {
            const existingEntry = list[entry.id] || {}

            Vue.set(list, entry.id, { ...existingEntry, ...entry })
          })
      }
    },

    REMOVE: (state, entries) => {
      const list = stateList(state[storeKey])

      if (isArray(list)) {
        castArray(entries)
          .map(entry => findIndex(list, 'id', entry.id))
          .filter(index => index !== -1)
          .forEach((index) => {
            list.splice(index)
          })
      } else if (isPlainObject(list)) {
        castArray(entries).forEach(({ id }) => {
          Vue.delete(list, id)
        })
      }
    },

    /**
     * Variation on ADD mutation. Instead of using Vue.set, uses direct assignment.
     */
    // ADJOIN: (state, entries) => {
    //   const list = stateList(state[storeKey])

    //   const entriesValues = (isPlainObject(entries) && entries[0])
    //     ? Object.values(entries)
    //     : entries

    //   castArray(entriesValues)
    //     .forEach((entry) => {
    //       Object
    //         .keys(entry)
    //         .filter(key => key !== 'id')
    //         .forEach((key) => {
    //           list[entry.id][key] = entry[key]
    //         })
    //     })
    // },

    SET_LAST_FETCH: (state, timestamp) => {
      state.lastFullFetch = timestamp
    },
  }

  if (isClearable) {
    storeMutations.CLEAR = (state) => {
      const list = stateList(state[storeKey])

      Object.keys(list).forEach((id) => {
        Vue.delete(list, id)
      })
    }
  }

  return Object
    .keys(storeMutations)
    .reduce((acc, key) => ({
      ...acc,
      [`${key}_${storeSuffix}`]: storeMutations[key],
    }), {})
}

const mutations = Object
  .values(modules)
  .filter(mod => mod.auto.has('mutations'))
  .reduce((acc, mod) => ({
    ...acc,
    ...buildStoreMutations(mod),
  }), {})

export default {
  ...mutations,
}



// WEBPACK FOOTER //
// ./src/store/mutations.js